import {
  categories,
  topics,
  type Category,
  type Topic,
} from "@/mocks/guaData";

export type RankPeriod = "day" | "week" | "month";

export function formatHeat(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return value.toLocaleString("zh-CN");
}

export function formatCount(value: number): string {
  if (value >= 10000) {
    return `${(value / 10000).toFixed(1)}万`;
  }
  return value.toLocaleString("zh-CN");
}

export function getCategoryBySlug(slug: string): Category | undefined {
  return categories.find((item) => item.slug === slug);
}

export function getTopicById(id: string): Topic | undefined {
  return topics.find((item) => item.id === id);
}

export function getTopicsByCategory(slug: string): Topic[] {
  return topics.filter((item) => item.categorySlug === slug);
}

export function getRankedTopics(period: RankPeriod = "day"): Topic[] {
  const key = period === "day" ? "heat" : period === "week" ? "heatWeek" : "heatMonth";
  return [...topics].sort((a, b) => b[key] - a[key]);
}

export function getRelatedTopics(topic: Topic, limit = 3): Topic[] {
  const sameCategory = topics.filter(
    (item) => item.categorySlug === topic.categorySlug && item.id !== topic.id,
  );
  const others = topics.filter(
    (item) => item.categorySlug !== topic.categorySlug && item.id !== topic.id,
  );
  return [...sameCategory, ...others].slice(0, limit);
}

export function getFeaturedTopics(limit = 4): Topic[] {
  const featured = topics.filter((item) => item.featured);
  if (featured.length >= limit) return featured.slice(0, limit);
  return [...featured, ...topics.filter((item) => !item.featured)].slice(0, limit);
}

export function getTrendMeta(trend: Topic["trend"]): { text: string; className: string; icon: string } {
  switch (trend) {
    case "up":
      return { text: "上升", className: "text-primary-600 bg-primary-100", icon: "ri-arrow-up-line" };
    case "down":
      return { text: "回落", className: "text-secondary-700 bg-secondary-100", icon: "ri-arrow-down-line" };
    case "new":
      return { text: "新进榜", className: "text-accent-800 bg-accent-100", icon: "ri-sparkling-line" };
    default:
      return { text: "持平", className: "text-foreground-600 bg-background-200", icon: "ri-subtract-line" };
  }
}

export const accentClassMap: Record<Category["accent"], { chip: string; dot: string }> = {
  primary: { chip: "bg-primary-100 text-primary-700", dot: "bg-primary-500" },
  accent: { chip: "bg-accent-100 text-accent-800", dot: "bg-accent-500" },
  secondary: { chip: "bg-secondary-100 text-secondary-700", dot: "bg-secondary-500" },
};